import LoadingIndicator from '@gameday/react-components/components/LoadingIndicator'

import commonStyles from 'shared/styles/common-styles.scss'

const LoadingPage = ({ label }) => (
  <div className={commonStyles.splashPageContainer}>
    <div className={commonStyles.contentContainer}>
      <LoadingIndicator />
      <h2>{label}</h2>
    </div>
  </div>
)

export default LoadingPage
